import { Action } from '@ngrx/store';

export enum FollowsActionTypes {
  Load = '[Follows] Load',
  LoadSuccess = '[Follows] Load Success',
  LoadFail = '[Follows] Load Fail',
  Follow = '[Follows] Follow',
  FollowSuccess = '[Follows] Follow Success',
  FollowFail = '[Follows] Follow Fail',
  Unfollow = '[Follows] Unfollow',
  PureUnfollow = '[Follows] Pure Unfollow',
  UnfollowSuccess = '[Follows] Unfollow Success',
  UnfollowFail = '[Follows] Unfollow Fail',
  FollowMultiple = '[Follows] Follow Multiple',
  FollowMultipleToggleSuccess = '[Follows] Follow Multiple Toggle Success',
  UnfollowMultiple = '[Follows] Unfollow Multiple',
  GroupFollow = '[GroupFollow] Follow',
  GroupFollowSuccess = '[GroupFollow] Follow Success',
  GroupFollowFail = '[GroupFollow] Follow Fail',
  GroupUnfollow = '[GroupFollow] Unfollow',
  GroupUnfollowSuccess = '[GroupFollow] Unfollow Success',
  GroupUnfollowFail = '[GroupFollow] Unfollow Fail',
  GroupFollowChannelSubscribe = '[GroupFollow] Channel Subscribe',
  GroupFollowUpdate = '[GroupFollow] Update',
  GroupUnfollowUpdate = '[GroupFollow] Unfollow Update'
}

export class Load implements Action {
  public readonly type = FollowsActionTypes.Load;
}

export class LoadSuccess implements Action {
  public readonly type = FollowsActionTypes.LoadSuccess;

  constructor(public payload: { follows: string[]; groupFollows: string[] }) {}
}

export class LoadFail implements Action {
  public readonly type = FollowsActionTypes.LoadFail;

  constructor(public payload: string) {}
}

export class Follow implements Action {
  public readonly type = FollowsActionTypes.Follow;
  constructor(public payload: string) {}
}

export class FollowSuccess implements Action {
  public readonly type = FollowsActionTypes.FollowSuccess;

  constructor(public payload: { dealId: string }) {}
}

export class FollowFail implements Action {
  public readonly type = FollowsActionTypes.FollowFail;

  constructor(public payload: { errorMessage: string; dealIds: string[] }) {}
}

export class Unfollow implements Action {
  public readonly type = FollowsActionTypes.Unfollow;
  constructor(public payload: string) {}
}

export class PureUnfollow implements Action {
  public readonly type = FollowsActionTypes.PureUnfollow;
  constructor(public payload: string) {}
}

export class UnfollowSuccess implements Action {
  public readonly type = FollowsActionTypes.UnfollowSuccess;

  constructor(public payload: { dealId: string }) {}
}

export class UnfollowFail implements Action {
  public readonly type = FollowsActionTypes.UnfollowFail;

  constructor(public payload: { errorMessage: string; dealIds: string[] }) {}
}

export class FollowMultiple implements Action {
  public readonly type = FollowsActionTypes.FollowMultiple;
  constructor(public payload: string[]) {}
}

export class FollowMultipleToggleSuccess implements Action {
  public readonly type = FollowsActionTypes.FollowMultipleToggleSuccess;

  constructor(
    public payload: { deals: string[]; dealIdsFollowInProcess: string[] }
  ) {}
}

export class UnfollowMultiple implements Action {
  public readonly type = FollowsActionTypes.UnfollowMultiple;
  constructor(public payload: string[]) {}
}

export class GroupFollow implements Action {
  public readonly type = FollowsActionTypes.GroupFollow;
  constructor(public payload: { dealId: string; notify: boolean }) {}
}

export class GroupFollowSuccess implements Action {
  public readonly type = FollowsActionTypes.GroupFollowSuccess;

  constructor(public payload: { dealId: string }) {}
}

export class GroupFollowFail implements Action {
  public readonly type = FollowsActionTypes.GroupFollowFail;

  constructor(public payload: { errorMessage: string; dealId: string }) {}
}

export class GroupUnfollow implements Action {
  public readonly type = FollowsActionTypes.GroupUnfollow;
  constructor(public payload: string) {}
}

export class GroupUnfollowSuccess implements Action {
  public readonly type = FollowsActionTypes.GroupUnfollowSuccess;

  constructor(public payload: { dealId: string }) {}
}

export class GroupUnfollowFail implements Action {
  public readonly type = FollowsActionTypes.GroupUnfollowFail;

  constructor(public payload: { errorMessage: string; dealId: string }) {}
}

export class GroupFollowChannelSubscribe implements Action {
  public readonly type = FollowsActionTypes.GroupFollowChannelSubscribe;
}

export class GroupFollowUpdate implements Action {
  public readonly type = FollowsActionTypes.GroupFollowUpdate;

  constructor(public payload: string) {}
}

export class GroupUnfollowUpdate implements Action {
  public readonly type = FollowsActionTypes.GroupUnfollowUpdate;

  constructor(public payload: string) {}
}

export type FollowsActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | Follow
  | FollowSuccess
  | FollowFail
  | Unfollow
  | PureUnfollow
  | UnfollowSuccess
  | UnfollowFail
  | FollowMultiple
  | FollowMultipleToggleSuccess
  | UnfollowMultiple
  | GroupFollow
  | GroupFollowSuccess
  | GroupFollowFail
  | GroupUnfollow
  | GroupUnfollowSuccess
  | GroupUnfollowFail
  | GroupFollowChannelSubscribe
  | GroupFollowUpdate
  | GroupUnfollowUpdate;
